import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const Registration = React.lazy(async () => ({
    default: (await import('@oc/registration/module')).RegistrationModule
}))

export function RegistrationComponent() {
    return <SuspenseWhileLoading LazyComponent={Registration} />
}
